const SESSION_STORAGE_KEY = 'tripper_session_id';

/**
 * Get or create a unique session ID for seat hold tracking.
 * Stored in sessionStorage so it survives page refresh but clears on browser close.
 * @returns {string} UUID session identifier
 */
function getSessionId() {
  let sessionId = sessionStorage.getItem(SESSION_STORAGE_KEY);
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem(SESSION_STORAGE_KEY, sessionId);
  }
  return sessionId;
}

export default getSessionId;
